const generateKeyWindowActionMatcher = (type, keyWindow) => {
  return (action) => {
    return (
      action.type === type &&
      action.payload &&
      action.payload.keyWindow === keyWindow
    );
  };
};

export default {
  generateKeyWindowActionMatcher,
};
